import { render, staticRenderFns } from "./AnnualReturnsMoreDetails.vue?vue&type=template&id=b7ac1a36&scoped=true&"
import script from "./AnnualReturnsMoreDetails.vue?vue&type=script&lang=js&"
export * from "./AnnualReturnsMoreDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ac1a36",
  null
  
)

export default component.exports